/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S10_Li3_TextInputs */

const tr_onbilgi_s10_li3_text = /** @type {(inputs: Onbilgi_S10_Li3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hesap girişinde e-posta + şifre + opsiyonel İki Faktörlü Doğrulama (MFA) desteklenir.`)
};

const en_onbilgi_s10_li3_text = /** @type {(inputs: Onbilgi_S10_Li3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account login supports email + password + optional Two Factor Authentication (MFA).`)
};

const de_onbilgi_s10_li3_text = /** @type {(inputs: Onbilgi_S10_Li3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei der Kontoanmeldung werden E-Mail + Passwort + optionale Zwei-Faktor-Authentifizierung (MFA) unterstützt.`)
};

const ru_onbilgi_s10_li3_text = /** @type {(inputs: Onbilgi_S10_Li3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При входе в учётную запись поддерживаются электронная почта + пароль + дополнительная двухфакторная аутентификация (MFA).`)
};

/**
* | output |
* | --- |
* | "Account login supports email + password + optional Two Factor Authentication (MFA)." |
*
* @param {Onbilgi_S10_Li3_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s10_li3_text = /** @type {((inputs?: Onbilgi_S10_Li3_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S10_Li3_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s10_li3_text(inputs)
	if (locale === "de") return de_onbilgi_s10_li3_text(inputs)
	if (locale === "ru") return ru_onbilgi_s10_li3_text(inputs)
	return tr_onbilgi_s10_li3_text(inputs)
});